"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SvgAccessibility = function SvgAccessibility(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.3,
    fill: "#A849FF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.917 7.99a3.596 3.596 0 0 1 3.61 3.595 3.596 3.596 0 0 1-3.61 3.595 3.596 3.596 0 0 1-3.609-3.595c0-1.926 1.611-3.595 3.61-3.595Zm-2.662 18.287c.258-1.027.278-3.33.342-4.614 0-.45-.258-.834-.644-.963l-7.927-2.375c-1.031-.32-1.611-1.412-1.29-2.375.323-.963 1.419-1.412 2.385-1.155 0 0 7.25 2.31 9.828 2.31 2.578 0 10.022-2.375 10.022-2.375.967-.256 2.062.321 2.32 1.284.258.963-.322 2.054-1.289 2.311L27.075 20.7c-.387.129-.709.514-.644.963.064 1.284.07 3.587.328 4.614.604 2.768 3.865 10.049 4.27 10.95.15.378.226.676.226.89a1.872 1.872 0 0 1-1.873 1.873c-.846 0-1.422-.593-1.793-1.331-.247-.492-1.46-2.972-3.64-7.44l-3.64 7.768-.062.102a1.871 1.871 0 0 1-3.474-.971c0-.323.082-.626.225-.89.402-.897 3.653-8.182 4.257-10.951Z",
    fill: "#A470D5",
    fillRule: "nonzero"
  })));
};

var _default = SvgAccessibility;
exports["default"] = _default;